const groupingObj = {
	'Ad Hoc': 3,
	'Appointment Group': 2,
	'Invigilator': 4,
	'Marker': 1,
	'Verifier': 5
};

export default groupingObj;